export const ROWS_PER_PAGE_OPTIONS = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '50', value: 50 },
];
export const PAGINATION_DEFAULT_LABEL = 'Page 0 of 0';
